export default __webpack_public_path__ + "static/media/nikkiso-hemodialysis.403e264c.jpg";